import { Company } from '../../../types/company/Company'

export interface ProductQueryParams {
  companyId?: Company['id']
}

const productQueryKeys = {
  all: [{ scope: 'product' }] as const,
  lists: () => [{ ...productQueryKeys.all[0], entity: 'list' }] as const,
  list: (params: ProductQueryParams) => [{ ...productQueryKeys.lists()[0], ...params }] as const
}

export default productQueryKeys
